/////////////////////////////////////////////////////////////////////////////////////////////////////////
//  컴포넌트명 : ImageLightbox (이미지 확대 미리보기)
//  설명 : 이미지를 화면 전체 위에 어둡게 깔고 화면 크기에 맞춰 크게 보여주는 창.
//        - 닫기 : 우측 상단 X / Esc / 이미지 바깥(배경) 클릭
//        - 다운로드 : 이미 화면에 있는 이미지 주소(blob)를 그대로 저장(추가 서버 요청 없음)
//        - document.body에 그려서(portal) 채팅 미니창(overflow:hidden)이나 다른 모달에 잘리지/가려지지 않음
//        상담톡 말풍선 이미지, 전송 전 첨부 썸네일(붙여넣은 화면캡처 포함)에서 공통으로 사용.
//  개발이력 : 2026.09.20  최초개발
/////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import '../styles/chatDesk.css'; // 상담톡 전용 스타일

interface ImageLightboxProps {
  src: string;        // 이미지 주소(blob URL 등)
  name: string;       // 파일명(상단 표시 + 다운로드 파일명)
  onClose: () => void;
}

const ImageLightbox: React.FC<ImageLightboxProps> = ({ src, name, onClose }) => {
  // Esc로 닫기 - 열려있는 동안만 리스너를 붙임
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div className="chatDesk-lightbox" onClick={onClose} role="dialog" aria-modal="true">
      <div className="chatDesk-lightbox-bar" onClick={e => e.stopPropagation()}>
        <span className="chatDesk-lightbox-name" title={name}>{name}</span>
        <a className="chatDesk-lightbox-btn" href={src} download={name} title="다운로드"><i className="fas fa-download" /> 다운로드</a>
        <button type="button" className="chatDesk-lightbox-btn" onClick={onClose} title="닫기 (Esc)"><i className="fas fa-times" /></button>
      </div>
      <img className="chatDesk-lightbox-img" src={src} alt={name} onClick={e => e.stopPropagation()} />
    </div>,
    document.body
  );
};

export default ImageLightbox;
